export default "__VITE_ASSET__i$b$nJ9L__"